import {action} from '@api'
import {WhiteboardStore} from '@modules/whiteboard/WhiteboardStore'

export class WhiteboardPreferencesStore {
  constructor(public store: WhiteboardStore) {}

  get ui() {
    return this.store.ui
  }

  @action toggleDebugMode = () => {
    this.ui.isDebugMode = !this.ui.isDebugMode
  }

  @action toggleDarkMode = () => {
    this.ui.isDarkMode = !this.ui.isDarkMode
  }

  @action toggleFocusMode = () => {
    this.ui.isFocusMode = !this.ui.isFocusMode
  }

  @action toggleRotateHandle = () => {
    this.ui.showRotateHandles = !this.ui.showRotateHandles
  }

  @action toggleBoundShapesHandle = () => {
    this.ui.showBindingHandles = !this.ui.showRotateHandles
  }

  @action toggleisSnapping = () => {
    this.ui.isSnapping = !this.ui.isSnapping
  }

  @action toggleCloneControls = () => {
    this.ui.showCloneHandles = !this.ui.showCloneHandles
  }
}



// WEBPACK FOOTER //
// ./src/modules/whiteboard/WhiteboardPreferencesStore.ts